import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import moment from 'moment';
import { toast } from 'react-toastify';
import exportUrl from '../../../exportUrl';
import { deliverReport } from '../../../utils/printPdf';
import { individualmemberlist, getIndividualReportData } from '../../../services/admin';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';

const IndividualReport = () => {
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    individualmemberlist().then(res => {
      if (res.status === true) {
        setMembers(res.data.map(m => ({ value: m.id, label: m.member_name })));
      }
    });
  }, []);

  useEffect(() => {

    const temp = new FormData();
    temp.append('from_date', fromDate);
    temp.append('to_date', toDate);
    temp.append('member_id', selectedMember ? selectedMember?.value : "");
    getIndividualReportData(temp).then(res => {
      if (res.status) {
        setReportData(res.data.details);
      } else {
        setReportData([]);
      }
    });
  }, [fromDate, toDate, selectedMember]);

  const handleDownload = (format) => {
    if (!fromDate || !toDate) {
      toast.error('Please select all filters');
      return;
    }
    let mem = selectedMember ? selectedMember.value : "";
    const url = `${exportUrl}report/individualreport?from_date=${fromDate}&to_date=${toDate}&member_id=${mem}&format=${format}`;
    deliverReport(url, format);
  };
  const columnDefs = [
    {
      headerName: "Due Date",
      field: "loan_duedate",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) =>
        params.value ? moment(params.value).format("DD-MM-YYYY") : "",
    },
    {
      headerName: "Paid Date",
      field: "loan_paiddate",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) =>
        params.value ? moment(params.value).format("DD-MM-YYYY") : "",
    },
    { headerName: "Member", field: "member_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Staff", field: "staff_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Loan Amount", field: "loanamount", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Principle", field: "loan_principle", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Interest", field: "loan_interest", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "EMI", field: "loan_total", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    {
      headerName: "OD",
      field: "loan_od",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    { headerName: "Paid", field: "loanpaid", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Remarks", field: "loan_remarks", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };
  return (

    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Individual Loan report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Report</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Individual Loan report
          </li>
        </ol>
      </div>
      <Card>
        <Card.Header>Individual Loan Report</Card.Header>
        <Card.Body>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>From Date</Form.Label>
                <Form.Control type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>To Date</Form.Label>
                <Form.Control type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Member</Form.Label>
                <Select options={members} value={selectedMember} onChange={setSelectedMember} placeholder="Select Member" />
              </Form.Group>
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <Button variant="danger" className="me-2" onClick={() => handleDownload('pdf')}>Download PDF</Button>
              <Button variant="success" className="me-2" onClick={() => handleDownload('excel')}>Download Excel</Button>
              <Button variant="primary" onClick={() => handleDownload('print')}>Print</Button>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12}>
              <div className="ag-theme-alpine">
                <AgGridReact
                  rowData={reportData}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  pagination={true}
                  paginationPageSize={10}
                />
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default IndividualReport;
